module.exports = __webpack_public_path__ + "img/LV3.9b9bd6ac.webp";